<style lang="scss" scoped>
.query-form-div {
    padding: 12px;
}

.body-div {
    padding: 12px;
}

.pagination-div {
    padding: 12px;
    text-align: right;
}

.handle-div {
    padding: 12px;
    text-align: right;
}
</style>
<template>
    <div v-loading="allLoading" element-loading-text="数据加载中...">
        <div class="query-form-div">
            <el-form :inline="true" :model="qForm">
                <el-form-item label="单位名称">
                    <el-input v-model="qForm.UnitName" placeholder="单位名称" size="small" />
                </el-form-item>
                <el-form-item label="登录账号">
                    <el-input v-model="qForm.LoginName" placeholder="登录账号" size="small" />
                </el-form-item>
                <el-form-item label="联系人">
                    <el-input v-model="qForm.UnitManagerName" placeholder="联系人" size="small" />
                </el-form-item>
                <el-form-item label="账号状态">
                    <el-select v-model="qForm.IsLock" size="small">
                        <el-option label="全部" value="" />
                        <el-option label="正常" value="0" />
                        <el-option label="锁定" value="1" />
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" :loading="allLoading" @click="query(true)"
                        size="small">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="body-div">
            <el-table :data="tb.data" style="width: 100%" stripe size="small" border>
                <el-table-column label="登录账号" prop="LoginName" />
                <el-table-column label="登录手机号" prop="LoginMobile" />
                <el-table-column label="单位名称" prop="UnitName">
                    <template v-slot="scope">
                        <span v-if="scope.row.UnitName">{{ scope.row.UnitName }}</span>
                        <span style="color: red;" v-else>未完善信息</span>
                    </template>
                </el-table-column>
                <el-table-column label="单位Logo" align="center" width="80">

                    <template v-slot="scope">
                        <el-image v-if="scope.row.UnitLogo" style=" height: 40px"
                            :src="fileRootPath + scope.row.SaveFolder + '/' + scope.row.UnitLogo + scope.row.FileSuffix"
                            :preview-src-list="[fileRootPath + scope.row.SaveFolder + '/' + scope.row.UnitLogo + scope.row.FileSuffix]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="单位负责人" prop="UnitManagerName" align="center" width="120" />
                <el-table-column label="联系方式" prop="UnitManagerPhone" align="center" width="120" />
                <el-table-column label="Email" prop="UnitEmail" align="center" width="150" />
                <el-table-column label="地址" prop="UnitAddress" />
                <el-table-column label="超级组" align="center" width="80">
                    <template slot-scope="scope">
                        <el-switch v-if="scope.row.UnitId" v-model="scope.row.IsSuper"
                            @change="setUnitIsSuper(scope.row)" active-color="#13ce66" inactive-color="#e3e3e3">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="账号状态" align="center" width="80">
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="scope.row.IsLock == 0 ? 'success' : 'danger'" disable-transitions>{{
                            scope.row.IsLock == 1 ?
                                "锁定" : "正常" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120">

                    <template slot-scope="scope">
                        <!-- <el-button size="mini" type="primary" @click.native.prevent="userRowEdit(scope.row)">
                            编辑
                        </el-button> -->
                         <el-tooltip size="mini" content="重置密码" placement="bottom" effect="light">
                        <el-button circle size="mini" icon="el-icon-refresh-right"  @click.native.prevent="resetPassword(scope.row)">
                        </el-button>
                         </el-tooltip>
                         <el-tooltip size="mini" content="解锁/锁定" placement="bottom" effect="light">
                        <el-button size="mini" circle :type="scope.row.IsLock == 1 ? 'success' : 'warning'"
                            :icon="scope.row.IsLock == 0 ? 'el-icon-lock' : 'el-icon-unlock'"
                            @click.native.prevent="changeStatus(scope.row)">
                        </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-div">
            <el-pagination background :current-page="tb.pi" :page-sizes="[10, 20, 40, 60, 100]" :page-size="tb.ps"
                layout="total, sizes, prev, pager, next, jumper" :total="tb.total" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </div>

    </div>
</template>
<script>
import UserInfoService from "@/request-server/request-services/userinfo-services.js";
import Url from '@/request-server/request-url';
export default {
    data() {
        return {
            allLoading: false,
            qForm: {
                LoginName: "",
                UnitName: '',
                UnitManagerName: '',
                UnitManagerPhone: '',
                IsLock: "",
            },
            roleList: [],
            tb: {
                pi: 1,
                ps: 10,
                total: 0,
                data: [],
            },
            dgUserInfo: {
                AccountId: "",
                LoginName: "",
                LoginPwd: "",
                ConfirmPwd: '',
                AccountType: 0,
            },
            dgUserInfoRules: {
                LoginName: [
                    {
                        required: true,
                        message: "请输入账号",
                        trigger: "blur",
                    },
                ],
                AccountType: [
                    {
                        required: true,
                        message: "请选择账号类型",
                        trigger: "blur",
                    },
                ],

                LoginPwd: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value.length < 6) {
                                callback(new Error("密码长度不能小于6位!"));
                            } else callback();
                        },
                        trigger: "blur",
                    },
                ],
                ConfirmPwd: [
                    {
                        required: true,
                        message: "请输入确认密码",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value != this.dgUserInfo.LoginPwd) {
                                callback(new Error("两次输入密码不一致!"));
                            } else callback();
                        },
                        trigger: "blur",
                    },
                ],

            },
            dgType: 0, // 0新增，1编辑
            dgUserInfoShow: false,
            dgUserInfoLoading: false,
            dgIsEditPwd: false,
            fileRootPath: ''
        };
    },
    created() {
        this.query();
        this.fileRootPath = Url.getDownloadBaseUrl() + 'uploadfiles/'
    },
    methods: {

        query(isInit) {
            if (isInit) {
                this.tb.pi = 1;
            }
            const qParams = {
                PageIndex: this.tb.pi,
                PageSize: this.tb.ps,
                Where: {
                    LoginName: this.qForm.LoginName,
                    IsLock: this.qForm.IsLock,
                    UnitName: this.qForm.UnitName,
                    UnitManagerName: this.qForm.UnitManagerName,
                    UnitManagerPhone: this.qForm.UnitManagerPhone,
                },
            };
            this.allLoading = true;
            UserInfoService.selectUnitAccountList(qParams).then((res) => {
                this.allLoading = false;
                if (res.code == 0) {
                    this.tb.data = res.data.Data;
                    this.tb.data.forEach(e => {
                        e.IsSuper = e.IsSuper == 1 ? true : false
                    })
                    this.tb.total = res.data.TotalRow;
                }
            });
        },
        handleSizeChange(val) {
            this.tb.ps = val;
            this.query(true);
        },
        handleCurrentChange(val) {
            this.tb.pi = val;
            this.query(false);
        },
        resetPassword(row) {
            console.log(row);
            this.$confirm(
                `确定要重置该单位登录密码`,
                "提示"
            ).then(() => {
                UserInfoService.resetPassword({ AccountId: row.AccountId }).then(resData => {
                    if (resData.code == 0) {
                        this.$alert(resData.data, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {

                            }
                        });

                    }
                })
            });
        },

        setUnitIsSuper(row) {
            let curr = !row.IsSuper;

            UserInfoService.setUnitIsSuper({ unitId: row.UnitId }).then(resData => {
                if (resData.code == 0 && resData.data == 'error') {
                    row.IsSuper = curr;
                    this.$message.warning('设置失败');
                }
            }).catch(() => {
                row.IsSuper = curr;
                this.$message.warning('设置失败');
            })
        },

        changeStatus(row) {
            this.$confirm(
                `确定要${row.IsLock == 0 ? "锁定" : "解锁"}该账号吗？`,
                "提示"
            ).then(() => {
                UserInfoService.lockOrUnlock({ id: row.AccountId }).then((res) => {
                    if (res.code == 0) {
                        this.$message.success(res.data);
                        this.query(false);
                    }
                });
            });
        },
        commitUserinfoDetail() {
            this.$refs["dgUserInfo"].validate((valid) => {
                if (valid) {
                    this.dgUserInfoLoading = true;
                    UserInfoService.editAccount(this.dgUserInfo)
                        .then((res) => {
                            this.dgUserInfoLoading = false;
                            if (res.code == 0) {
                                this.$message.success(res.data);
                                this.dgUserInfo = {
                                    AccountId: "",
                                    LoginName: "",
                                    LoginPwd: "",
                                    ConfirmPwd: "",
                                    AccountType: 0,
                                };
                                this.dgUserInfoShow = false;
                                this.query(true);
                            }
                        })
                        .finally(() => (this.dgUserInfoLoading = false));
                }
            });
        },
        isEditPwd() {
            this.dgIsEditPwd = true;
        },
    },
    computed: {

    },
};
</script>
